import { useTranslation } from "@opendash/i18n";
import { $parse } from "@opendash/plugin-parse";
import { Checkbox, Form, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext, useMemo } from "react";
import { PathContext } from "../../../../context/PathContext";
import {
  ClassNameFieldExtensions,
  SelectParseWithClass,
} from "../../../../types/field_configs/Meta";
import { ParseSelectSpecificOptions } from "./parse_select/ParseSelectSpecificOptions";

type Props<
  K extends keyof ClassNameFieldExtensions = keyof ClassNameFieldExtensions,
> = {
  field: SelectParseWithClass<K>;
  name?: string;
};

export const ParseSelectOptions = observer((props: Props) => {
  const t = useTranslation();
  const path = useContext(PathContext);
  const schema = $parse.server.schema;
  const currentClass = schema.find(
    (item) => item.className === props.field?.className
  );

  const fieldOptions = useMemo(() => {
    const fields = currentClass?.fields || [];
    const options: { value: string }[] = [];
    for (const field in fields) {
      const currentField = fields[field];

      if (currentField.type === "String") {
        options.push({
          value: field,
        });
      }
    }
    return options;
  }, [currentClass]);

  return (
    <>
      <Form.Item
        name={[...path, "className"]}
        label={t("maintenance:ticket.creation.config.form.field.className")}
      >
        <Select
          showSearch
          options={schema.map((item) => ({
            value: item.className,
          }))}
        />
      </Form.Item>

      {currentClass?.fields && (
        <Form.Item
          name={[...path, "display"]}
          label={t("maintenance:ticket.creation.config.form.field.display")}
        >
          <Select options={fieldOptions} />
        </Form.Item>
      )}

      <Form.Item
        name={[...path, "multiple"]}
        label={t("maintenance:ticket.creation.config.form.field.multiple")}
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>

      <ParseSelectSpecificOptions field={props.field} />
    </>
  );
});
